<section class="content">
  <div class="card" style="padding: 25px">
    <div class="row">
      <div class="col" style="font-size: 23px;font-weight: 500; color: #cd3a27; margin-bottom: 25px;">
        {{title}}
      </div>
    </div>

    <!-- Filter Controls -->
    <div class="row" style="padding-bottom: 25px;">
      <div class="col-md-3">
        <label for="employeeType" style="font-weight: 500; margin-bottom: 5px;">Employee Type:</label>
        <select id="employeeType" class="form-control" [(ngModel)]="selectedEmployeeType">
          <option value="">Select Employee Type</option>
          <option *ngFor="let type of employeeTypes" [value]="type">{{type}}</option>
        </select>
      </div>

      <div class="col-md-3">
        <label for="month" style="font-weight: 500; margin-bottom: 5px;">Month:</label>
        <select id="month" class="form-control" [(ngModel)]="selectedMonth">
          <option *ngFor="let month of months" [value]="month.value">{{month.name}}</option>
        </select>
      </div>

      <div class="col-md-3">
        <label for="year" style="font-weight: 500; margin-bottom: 5px;">Year:</label>
        <select id="year" class="form-control" [(ngModel)]="selectedYear">
          <option *ngFor="let year of years" [value]="year">{{year}}</option>
        </select>
      </div>

      <div class="col-md-3" style="display: flex; align-items: end;">
        <button mat-raised-button color="primary" (click)="downloadExcel()" [disabled]="!canDownload()"
          style="width: 100%;">
          <mat-icon *ngIf="!isDownloading">file_download</mat-icon>
          <mat-progress-spinner *ngIf="isDownloading" [diameter]="20" mode="indeterminate" color="primary">
          </mat-progress-spinner>
          {{isDownloading ? 'Downloading...' : 'Download Excel'}}
        </button>
      </div>
    </div>

    <!-- Validation Message -->
    <div class="row" *ngIf="selectedEmployeeType !== '' && !isValidMonthYear()" style="margin-bottom: 15px;">
      <div class="col">
        <div class="alert alert-warning" role="alert">
          <strong>Warning:</strong> Please select a month and year that is not greater than the current month and year.
        </div>
      </div>
    </div>

    <div *ngIf="!is_data_available">
      <mat-progress-spinner class="example-margin" [color]="color" [mode]="mode" [diameter]="100">
      </mat-progress-spinner>
    </div>
    <div class="row" *ngIf="is_data_available">
      <div class="col">
        <table class="table table-bordered table-striped">
          <tr style="background: #97cdef; text-align: center;">
            <th>S. No.</th>
            <th>Customr Code</th>
            <th>Delivery Month</th>
            <th>Shift</th>
            <th>Amount</th>
            <th>Order Placed By</th>
            <th>Order Placed@</th>
            <th>Order Deleted By</th>
            <th>Order Deleted@</th>
          </tr>

          <tr *ngFor="let data of delete_log_data; let log_index=index">
            <td>{{ log_index + 1 }}</td>
            <td style="text-align: center;">{{ data['customer__customer_code'] }}</td>
            <td style="text-align: center;">{{ data['date_of_delivery'] | date : 'MMM' }}</td>
            <td style="text-align: center;">{{ data['deleted_value_json']['session_name']}}</td>
            <td style="text-align: right;">{{ data['deleted_value_json']['total_cost_for_month'] | currency: 'INR' }}
            </td>
            <td>{{ data['ordered_by__first_name'] }}</td>
            <td>{{ data['ordered_on'] | date : 'MMM d, y, h:mm a' }}</td>
            <td>{{ data['deleted_by__first_name'] }}</td>
            <td>{{ data['deleted_on'] | date : 'MMM d, y, h:mm a' }}</td>
          </tr>
        </table>
        <div style="font-size: 36px;" *ngIf="delete_log_data.length == 0">There Is No Log !!!</div>
      </div>
    </div>
  </div>
</section>